import { TimeView } from '@mui/x-date-pickers/models';
import { IErrorMessage } from '@shared/hooks/use-error-message';
import {
  DeviceGroupScheduleModel,
  ScheduleWeekDayApi,
  WeekDayEnum
} from '@models/digital-signage/device-group-schedules.model.ts';
import {
  ScheduleDateErrorEnum,
  ScheduleDatePickerProps,
  ScheduleDayPresetEnum
} from '@modules/digital-signage/model/playlist-schedule.model.ts';

export const TIME_PICKER_VIEW = {
  Hours: 'hours',
  Minutes: 'minutes'
} as const satisfies Record<string, TimeView>;

export const DAY_MINUTES = 1440;
export const SCHEDULE_MINUTES_STEP = 5;
export const MIN_FREE_SLOT = 15;
export const DATE_FORMAT = 'YYYY-MM-DD';
export const LOCAL_SCHEDULE_ID_PREFIX = 'local-';

export const isLocalSchedule = ({
  _id
}: Pick<DeviceGroupScheduleModel, '_id'>): boolean =>
  _id.startsWith(LOCAL_SCHEDULE_ID_PREFIX);

export const WEEK_DAYS = Object.values(WeekDayEnum).filter(
  (day): day is WeekDayEnum => typeof day === 'number'
);

/** API week days in WeekDayEnum order */
export const WEEK_DAYS_API: ScheduleWeekDayApi[] = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun'
];

export const SCHEDULE_DAY_PRESETS: Record<
  ScheduleDayPresetEnum,
  WeekDayEnum[]
> = {
  [ScheduleDayPresetEnum.Weekdays]: WEEK_DAYS.slice(0, 5),
  [ScheduleDayPresetEnum.Weekend]: WEEK_DAYS.slice(5),
  [ScheduleDayPresetEnum.All]: WEEK_DAYS
};

export const scheduleErrorMessages: IErrorMessage = {
  name: {
    required: 'validation_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  playlist: {
    required: 'validation_digital_signage_schedule_playlist_required'
  },
  startDate: {
    required: 'validation_start_date_required',
    invalidDate: 'validation_date_invalid'
  },
  endDate: {
    required: 'validation_end_date_required',
    invalidDate: 'validation_date_invalid'
  }
};

export const SCHEDULE_DATE_ERROR_FIELD: Record<
  ScheduleDateErrorEnum,
  ScheduleDatePickerProps['name']
> = {
  [ScheduleDateErrorEnum.EndBeforeStart]: 'endDate',
  [ScheduleDateErrorEnum.StartInPast]: 'startDate',
  [ScheduleDateErrorEnum.EndInPast]: 'endDate'
};

export const getScheduleDateErrorKey = (
  dateError: ScheduleDateErrorEnum | null,
  field: ScheduleDatePickerProps['name']
): string =>
  dateError && SCHEDULE_DATE_ERROR_FIELD[dateError] === field
    ? `digital_signage_schedule_date_error_${dateError}`
    : '';
